import { cn } from "../lib/utils";
import { NavLink, NavLinkRenderProps } from "react-router";

interface TabsProps {
  tabs: {
    label: string;
    link: string;
  }[];
}

export function Tabs({ tabs }: TabsProps) {
  return (
    <div className="flex gap-4 w-full border-b border-gray-200">
      {tabs.map((tab) => (
        <div key={tab.link} className="flex items-center justify-center">
          <NavLink
            to={tab.link}
            end
            viewTransition
            className={(props: NavLinkRenderProps) =>
              cn(
                "py-2 border-0! rounded-none!",
                props.isActive
                  ? "text-black border-b-2! border-primary"
                  : "text-gray-500"
              )
            }
          >
            {tab.label}
          </NavLink>
        </div>
      ))}
    </div>
  );
}
